import type { DrawerProps } from 'antd';
import { useBreakpoint } from './useBreakpoint';

const DEFAULT_SIDE_DRAWER_WIDTH = 440;
const BOTTOM_SHEET_HEIGHT = 'auto';

export type DrawerSurfaceProps = Pick<DrawerProps, 'placement' | 'width' | 'height'>;

export const useDrawerSurface = (
  sideWidth: number = DEFAULT_SIDE_DRAWER_WIDTH,
): DrawerSurfaceProps => {
  const { isMobile } = useBreakpoint();

  return isMobile
    ? { placement: 'bottom', height: BOTTOM_SHEET_HEIGHT }
    : { placement: 'right', width: sideWidth };
};
